import script from "./HelpNavItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpNavItem.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__